// Hook pro čtení vrstvy, kterou list-detail root právě zobrazuje v detail panelu

import { useMemo } from 'react';
import { useNavigationStore } from './useNavigationContext';

/** Vrstva v detail zóně (pravý panel list-detail rootu). */
export interface DetailZoneLayer {
  readonly layerId: string;
  readonly agendaId: string;
  /** `state` parametry vrstvy — surové hodnoty, čtenář nezná její codec kontrakt. */
  readonly state: Readonly<Record<string, unknown>>;
}

/**
 * Vrátí vrstvu, kterou list-detail root zobrazuje v detail panelu (`zone: 'detail'`), nebo `null`.
 *
 * Slouží LISTU (treeview, toolbar), který se podle otevřeného detailu rozhoduje, co otevřít dál —
 * je to jediná vrstva, jejíž obsah list řídí. Konzumenti agendy tímto číst NESMÍ: vlastní parametry
 * čtou přes `useAgendaParams` a na cizí vrstvy ani na hloubku stacku se nesmí spoléhat.
 */
export function useDetailZone(): DetailZoneLayer | null {
  const navigation = useNavigationStore((s) => s.navigation);

  return useMemo(() => {
    const layer = navigation.layers.find((l) => l.stackId === undefined && l.zone === 'detail');
    if (!layer) return null;
    return { layerId: layer.layerId, agendaId: layer.agendaId, state: layer.stateParams };
  }, [navigation]);
}
